(() => {
  const QUIZ_SELECTOR = '[data-kalaboost-quiz]';
  const OPEN_SELECTOR = '[data-kalaboost-quiz-open]';
  const TOTAL_STEPS = 6;

  const QUESTIONS = [
    {
      id: 'q1',
      label: 'Question 1',
      text: 'Vous êtes ?',
      options: [
        { id: 'homme', label: 'Un homme' },
        { id: 'femme', label: 'Une femme' },
      ],
    },
    {
      id: 'q2',
      label: 'Question 2',
      text: "Quelle est votre préoccupation principale aujourd'hui ?",
      options: [
        { id: 'chute', label: "Je perds beaucoup de cheveux, ça s'accélère" },
        { id: 'affinement', label: "Mes cheveux s'affinent, des zones deviennent plus clairsemées" },
        { id: 'cuir_chevelu', label: 'Mon cuir chevelu est sec, inconfortable, tiraille' },
        { id: 'prevention', label: "Je veux prévenir et renforcer avant que ça s'aggrave" },
      ],
    },
    {
      id: 'q3',
      label: 'Question 3',
      text: 'Depuis combien de temps observez-vous ce problème ?',
      options: [
        { id: 'moins_3_mois', label: 'Moins de 3 mois' },
        { id: '3_12_mois', label: 'Entre 3 et 12 mois' },
        { id: 'plus_1_an', label: "Plus d'un an" },
      ],
    },
    {
      id: 'q4',
      label: 'Question 4',
      text: 'Avez-vous déjà essayé un produit anti-chute ciblé ?',
      options: [
        { id: 'jamais', label: 'Non, jamais' },
        { id: 'sans_resultat', label: 'Oui, sans résultat convaincant' },
        { id: 'deja_teste', label: "Oui, j'ai déjà testé une solution" },
      ],
    },
    {
      id: 'q5',
      label: 'Question 5',
      text: "Qu'est-ce qui compte le plus pour vous aujourd'hui ?",
      options: [
        { id: 'routine_complete', label: 'Une routine complète, clé en main' },
        { id: 'cuir_chevelu', label: 'Cibler le cuir chevelu directement, un geste précis' },
        { id: 'nourrir', label: "Nourrir de l'intérieur, en complément de mes soins" },
        { id: 'geste_doux', label: 'Un geste quotidien doux, en plus de ma routine actuelle' },
      ],
    },
    {
      id: 'q6',
      label: 'Question 6',
      text: "Êtes-vous enceinte, allaitante, sous traitement antibiotique, ou souffrez-vous d'insuffisance cardiaque ou rénale ?",
      options: [
        { id: 'oui', label: 'Oui' },
        { id: 'non', label: 'Non' },
      ],
    },
  ];

  const CONCERN_RECAP = {
    chute: "la chute s'accélère",
    affinement: "vos cheveux s'affinent et des zones deviennent plus clairsemées",
    cuir_chevelu: 'votre cuir chevelu est sec ou inconfortable',
    prevention: 'vous souhaitez prévenir et renforcer vos cheveux',
  };

  const DURATION_RECAP = {
    moins_3_mois: 'depuis moins de 3 mois',
    '3_12_mois': 'depuis entre 3 et 12 mois',
    plus_1_an: "depuis plus d'un an",
  };

  const RESULT_PROFILES = {
    routine: { productKeys: ['routine'], layout: 'pack' },
    pack_expert: { productKeys: ['pack_expert'], layout: 'pack' },
    external: { productKeys: ['lotion', 'serum', 'shampooing'] },
  };

  const HIGHLIGHTS = {
    chute: ['lotion-anti-chute-2-en-1'],
    affinement: ['lotion-anti-chute-2-en-1'],
    cuir_chevelu: ['shampooing', 'serum-hydratant-activateur-anti-chute'],
    prevention: [],
  };

  const escapeHtml = (value) =>
    String(value ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');

  const formatMoney = (cents) => {
    const value = Number(cents);
    if (!Number.isFinite(value) || value <= 0) return '';
    return `${(value / 100).toLocaleString('fr-FR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })} €`;
  };

  const getConfig = () => {
    const configEl = document.querySelector('[data-kalaboost-quiz-config]');
    if (!configEl) return { products: {} };
    try {
      return JSON.parse(configEl.textContent);
    } catch {
      return { products: {} };
    }
  };

  const isPackExpertProfile = (answers) =>
    answers.q3 === 'plus_1_an' &&
    answers.q4 === 'sans_resultat' &&
    answers.q5 === 'routine_complete';

  const determineResult = (answers) => {
    if (answers.q6 === 'oui') {
      return {
        resultId: 'external',
        concern: answers.q2,
        healthNotice: true,
      };
    }

    if (isPackExpertProfile(answers)) {
      return {
        resultId: 'pack_expert',
        concern: answers.q2,
        healthNotice: false,
      };
    }

    return {
      resultId: 'routine',
      concern: answers.q2,
      healthNotice: false,
    };
  };

  const buildRecap = (answers) => {
    const parts = [];
    if (CONCERN_RECAP[answers.q2]) parts.push(`que ${CONCERN_RECAP[answers.q2]}`);
    if (DURATION_RECAP[answers.q3]) parts.push(DURATION_RECAP[answers.q3]);
    if (!parts.length) return '';
    return `Vous nous avez dit ${parts.join(', ')}.`;
  };

  const getDiagnosticCopy = (answers, resultId) => {
    const concern = answers.q2;

    if (resultId === 'external') {
      if (concern === 'cuir_chevelu') {
        return {
          title: 'Votre routine de soins externes',
          text: 'Le complément alimentaire n’est pas adapté à votre situation. Nous vous proposons donc une routine composée uniquement de soins externes, avec un focus confort du cuir chevelu : sérum, shampoing et lotion.',
          intro: 'Sérum, shampoing et lotion agissent à l’extérieur, sans complément alimentaire.',
        };
      }
      if (concern === 'prevention') {
        return {
          title: 'Votre routine de soins externes',
          text: 'Le complément alimentaire n’est pas adapté à votre situation. Pour prévenir et renforcer malgré tout, nous vous proposons une routine de soins externes à suivre avec régularité.',
          intro: 'Lotion, sérum et shampoing suffisent à construire un geste quotidien, sans complément.',
        };
      }
      return {
        title: 'Votre routine de soins externes',
        text: 'Le complément alimentaire n’est pas adapté à votre situation. Nous vous proposons donc une routine composée uniquement de soins externes : lotion, sérum et shampoing, pour continuer à cibler le cuir chevelu.',
        intro: 'Lotion, sérum et shampoing agissent ensemble, sans complément alimentaire.',
      };
    }

    if (resultId === 'pack_expert') {
      return {
        title: 'Votre Pack Expert Repousse',
        text: 'Votre problème est installé depuis plus d’un an, et les solutions déjà testées n’ont pas convaincu. Le Pack Expert Repousse est le protocole le plus intensif de la gamme, pour une approche complète.',
        intro: 'Shampoing, lotion et complément agissent ensemble dans le protocole le plus complet. La brosse est offerte.',
      };
    }

    if (concern === 'chute') {
      return {
        title: 'Votre Hair Boost Routine',
        text: 'Votre priorité est de cibler directement le cuir chevelu tout en accompagnant votre routine de manière globale. La Hair Boost Routine réunit les différents gestes Kalaboost dans un seul protocole.',
        intro: 'La lotion agit à la racine, pendant que le shampoing et le complément complètent le protocole. La brosse est offerte.',
      };
    }

    if (concern === 'affinement') {
      return {
        title: 'Votre Hair Boost Routine',
        text: 'Vos cheveux s’affinent et des zones deviennent plus clairsemées. Une routine complète, suivie avec régularité, est le meilleur levier pour accompagner la densité. La Hair Boost Routine rassemble ces gestes dans un seul protocole.',
        intro: 'La lotion cible le cuir chevelu au quotidien, dans une routine globale à tenir dans le temps. La brosse est offerte.',
      };
    }

    if (concern === 'cuir_chevelu') {
      return {
        title: 'Votre Hair Boost Routine',
        text: 'Votre cuir chevelu est sec ou inconfortable. La Hair Boost Routine reste le protocole le plus complet : un shampoing doux au quotidien, dans une approche globale.',
        intro: 'Le shampoing apaise le cuir chevelu, pendant que la lotion et le complément complètent la routine. La brosse est offerte.',
      };
    }

    return {
      title: 'Votre Hair Boost Routine',
      text: 'Vous souhaitez prévenir et renforcer vos cheveux. La régularité d’une routine globale est plus efficace qu’un geste isolé. La Hair Boost Routine pose ce cadre, jour après jour.',
      intro: 'Shampoing, lotion et complément agissent ensemble pour anticiper, avant que la situation ne s’aggrave. La brosse est offerte.',
    };
  };

  const highlightHandlesFor = (concern) => HIGHLIGHTS[concern] || [];

  const trackEvent = (eventName, params = {}) => {
    if (typeof window.dataLayer !== 'undefined') {
      window.dataLayer.push({ event: eventName, ...params });
    }
  };

  class KalaboostQuiz {
    constructor(root) {
      this.root = root;
      this.config = getConfig();
      this.answers = {};
      this.currentStep = 'intro';
      this.questionIndex = 0;

      this.overlay = root.querySelector('[data-kalaboost-quiz-overlay]');
      this.panel = root.querySelector('[data-kalaboost-quiz-panel]');
      this.progress = root.querySelector('[data-kalaboost-quiz-progress]');
      this.progressBar = root.querySelector('[data-kalaboost-quiz-progress-bar]');
      this.progressLabel = root.querySelector('[data-kalaboost-quiz-progress-label]');
      this.body = root.querySelector('[data-kalaboost-quiz-body]');

      this.stepIntro = root.querySelector('[data-kalaboost-quiz-step="intro"]');
      this.stepQuestion = root.querySelector('[data-kalaboost-quiz-step="question"]');
      this.stepResult = root.querySelector('[data-kalaboost-quiz-step="result"]');

      this.questionLabel = root.querySelector('[data-kalaboost-quiz-question-label]');
      this.questionText = root.querySelector('[data-kalaboost-quiz-question]');
      this.optionsContainer = root.querySelector('[data-kalaboost-quiz-options]');
      this.backButton = root.querySelector('[data-kalaboost-quiz-back]');

      this.resultTitleEl = root.querySelector('[data-kalaboost-quiz-result-title]');
      this.summaryEl = root.querySelector('[data-kalaboost-quiz-summary]');
      this.noticeEl = root.querySelector('[data-kalaboost-quiz-notice]');
      this.productsEl = root.querySelector('[data-kalaboost-quiz-products]');
      this.reassuranceEl = root.querySelector('[data-kalaboost-quiz-reassurance]');

      this.bindEvents();
    }

    bindEvents() {
      this.root.querySelector('[data-kalaboost-quiz-close]')?.addEventListener('click', () => this.close());
      this.overlay?.addEventListener('click', () => this.close());
      this.root.querySelector('[data-kalaboost-quiz-start]')?.addEventListener('click', () => this.start());
      this.root.querySelector('[data-kalaboost-quiz-restart]')?.addEventListener('click', () => this.restart());
      this.backButton?.addEventListener('click', () => this.goBack());

      document.addEventListener('keydown', (event) => {
        if (!this.isOpen()) return;
        if (event.key === 'Escape') this.close();
      });
    }

    isOpen() {
      return !this.root.hidden;
    }

    open() {
      const menuDrawer = document.querySelector('#Details-menu-drawer-container');
      if (menuDrawer?.hasAttribute('open')) {
        menuDrawer.removeAttribute('open');
      }

      this.root.hidden = false;
      this.root.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      this.restart();
      trackEvent('kalaboost_quiz_open');
    }

    close() {
      this.root.hidden = true;
      this.root.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    restart() {
      this.answers = {};
      this.questionIndex = 0;
      this.showStep('intro');
      this.progress.hidden = true;
    }

    start() {
      this.questionIndex = 0;
      this.showQuestion(0);
      trackEvent('kalaboost_quiz_start');
    }

    showStep(step) {
      this.currentStep = step;
      this.stepIntro.hidden = step !== 'intro';
      this.stepQuestion.hidden = step !== 'question';
      this.stepResult.hidden = step !== 'result';
      if (step !== 'result') {
        this.panel?.classList.remove('kalaboost-quiz__panel--offer');
        this.productsEl?.classList.remove('kalaboost-quiz__products--offer');
        if (this.reassuranceEl) this.reassuranceEl.hidden = false;
      }
    }

    showQuestion(index) {
      const question = QUESTIONS[index];
      if (!question) {
        this.showResult();
        return;
      }

      this.questionIndex = index;
      this.showStep('question');
      this.progress.hidden = false;

      const displayIndex = index + 1;
      this.progressBar.style.width = `${(displayIndex / TOTAL_STEPS) * 100}%`;
      this.progressLabel.textContent = `Étape ${displayIndex} sur ${TOTAL_STEPS}`;

      this.questionLabel.textContent = question.label;
      this.questionText.textContent = question.text;
      this.backButton.hidden = index === 0;

      this.renderOptions(question);
      trackEvent('kalaboost_quiz_question', {
        question_id: question.id,
        step: displayIndex,
        gender: this.answers.q1 || '',
      });
    }

    renderOptions(question) {
      this.optionsContainer.innerHTML = '';
      const currentAnswer = this.answers[question.id];

      question.options.forEach((option) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'kalaboost-quiz__option';
        button.setAttribute('role', 'option');
        button.dataset.optionId = option.id;

        if (currentAnswer === option.id) {
          button.classList.add('is-selected');
        }

        button.innerHTML = `
          <span class="kalaboost-quiz__option-marker" aria-hidden="true"></span>
          <span>${escapeHtml(option.label)}</span>
        `;

        button.addEventListener('click', () => this.selectOption(question, option.id));
        this.optionsContainer.appendChild(button);
      });
    }

    selectOption(question, optionId) {
      this.answers[question.id] = optionId;

      const nextIndex = this.questionIndex + 1;
      if (nextIndex < QUESTIONS.length) {
        setTimeout(() => this.showQuestion(nextIndex), 180);
      } else {
        setTimeout(() => this.showResult(), 180);
      }
    }

    goBack() {
      if (this.questionIndex <= 0) {
        this.showStep('intro');
        this.progress.hidden = true;
        return;
      }
      this.showQuestion(this.questionIndex - 1);
    }

    renderProductCard(productKey, { priority = false } = {}) {
      const product = this.config.products?.[productKey];
      if (!product) return '';

      const statsHtml = (product.stats || [])
        .map(
          (stat) =>
            `<li class="kalaboost-quiz__product-stat"><strong>${escapeHtml(stat.percent)}</strong> ${escapeHtml(stat.text)}</li>`
        )
        .join('');

      const imageHtml = product.image
        ? `<img class="kalaboost-quiz__product-image" src="${escapeHtml(product.image)}" alt="" width="100" height="100" loading="lazy">`
        : '<span class="kalaboost-quiz__product-image kalaboost-quiz__product-image--placeholder" aria-hidden="true"></span>';

      return `
        <article class="kalaboost-quiz__product${priority ? ' is-priority' : ''}">
          ${imageHtml}
          <div>
            ${priority ? '<p class="kalaboost-quiz__product-badge">À prioriser</p>' : ''}
            <h3 class="kalaboost-quiz__product-name">${escapeHtml(product.title)}</h3>
            ${statsHtml ? `<ul class="kalaboost-quiz__product-stats">${statsHtml}</ul>` : ''}
            <a class="kalaboost-quiz__product-cta" href="${escapeHtml(product.url)}">
              Découvrir
            </a>
          </div>
        </article>
      `;
    }

    renderPackOffer(productKey, { intro, highlightHandles = [] } = {}) {
      const pack = this.config.products?.[productKey];
      const shared = this.config.packOffer || {};
      const copy = shared.offers?.[productKey] || {};
      if (!pack) return '';

      const components = (shared.components || []).filter(Boolean);
      const brush = shared.brush;
      const packCents = Number(pack.price) || 0;
      const listCents =
        components.reduce((sum, item) => sum + (Number(item.priceCents) || 0), 0) +
        (Number(brush?.priceCents) || 0);
      const savingsCents = Math.max(0, listCents - packCents);

      const cards = components.map((item) => ({
        name: item.name || item.title || '',
        image: item.image,
        handle: item.handle || '',
        gift: false,
      }));
      if (brush) {
        cards.push({
          name: brush.name || 'Brosse',
          image: brush.image,
          handle: '',
          gift: true,
        });
      }

      const bundleHtml = cards
        .map((card, index) => {
          const plus = index > 0
            ? '<span class="kalaboost-quiz__routine-plus" aria-hidden="true">+</span>'
            : '';
          const image = card.image
            ? `<img class="kalaboost-quiz__routine-card-image" src="${escapeHtml(card.image)}" alt="${escapeHtml(card.name)}" width="80" height="80" loading="lazy">`
            : '<span class="kalaboost-quiz__routine-card-empty" aria-hidden="true"></span>';
          const ribbon = card.gift
            ? '<span class="kalaboost-quiz__routine-ribbon">Offerte</span>'
            : '';
          const highlighted = !card.gift && highlightHandles.includes(card.handle);
          const badge = highlighted
            ? '<span class="kalaboost-quiz__routine-priority">Priorité</span>'
            : '';

          return `
            ${plus}
            <article class="kalaboost-quiz__routine-card${card.gift ? ' kalaboost-quiz__routine-card--gift' : ''}${highlighted ? ' is-highlighted' : ''}">
              ${ribbon}
              ${badge}
              <div class="kalaboost-quiz__routine-card-frame">${image}</div>
              <p class="kalaboost-quiz__routine-card-name">${escapeHtml(card.name)}</p>
            </article>
          `;
        })
        .join('');

      const perksHtml = (shared.perks || [])
        .map((perk) => {
          if (!perk) return '';
          if (String(perk).includes('[economie]') && savingsCents <= 0) return '';
          const text = String(perk).replaceAll('[economie]', formatMoney(savingsCents));
          return `<li><span aria-hidden="true">✓</span><span>${escapeHtml(text)}</span></li>`;
        })
        .filter(Boolean)
        .join('');

      const packPrice = formatMoney(packCents);
      const compareHtml = listCents > packCents
        ? `<s>${escapeHtml(formatMoney(listCents))}</s>`
        : '';
      const saveHtml = savingsCents > 0
        ? `<p class="kalaboost-quiz__routine-save"><strong>− ${escapeHtml(formatMoney(savingsCents))}</strong> Économie</p>`
        : '';
      const offerIntro = intro || copy.intro || shared.intro || '';
      const footer = shared.footer || 'Garantie 90 jours satisfait ou remboursé';
      const cta = copy.cta || 'Découvrir le pack';
      const kicker = copy.kicker || 'Routine recommandée';
      const packNote = copy.packNote || '';

      return `
        <article class="kalaboost-quiz__routine">
          <div class="kalaboost-quiz__routine-copy">
            <p class="kalaboost-quiz__routine-kicker">${escapeHtml(kicker)}</p>
            <h3 class="kalaboost-quiz__routine-title">${escapeHtml(pack.title)}</h3>
            ${offerIntro ? `<p class="kalaboost-quiz__routine-intro">${escapeHtml(offerIntro)}</p>` : ''}
            ${bundleHtml ? `<div class="kalaboost-quiz__routine-bundle">${bundleHtml}</div>` : ''}
            <div class="kalaboost-quiz__routine-deal">
              <div>
                <p class="kalaboost-quiz__routine-price">
                  <span>${escapeHtml(packPrice)}</span>
                  ${compareHtml}
                </p>
                ${packNote ? `<p class="kalaboost-quiz__routine-note">${escapeHtml(packNote)}</p>` : ''}
              </div>
              ${saveHtml}
            </div>
            ${perksHtml ? `<ul class="kalaboost-quiz__routine-perks">${perksHtml}</ul>` : ''}
            <a class="kalaboost-quiz__routine-cta" href="${escapeHtml(pack.url)}">
              ${escapeHtml(cta)}
            </a>
            <div class="kalaboost-quiz__routine-footer">
              <p>${escapeHtml(footer)}</p>
            </div>
          </div>
        </article>
      `;
    }

    showResult() {
      const { resultId, concern, healthNotice } = determineResult(this.answers);
      const profile = RESULT_PROFILES[resultId] || RESULT_PROFILES.routine;
      const copy = getDiagnosticCopy(this.answers, resultId);
      const recap = buildRecap(this.answers);
      const highlights = highlightHandlesFor(concern);

      this.showStep('result');
      this.progress.hidden = false;
      this.progressBar.style.width = '100%';
      this.progressLabel.textContent = 'Diagnostic terminé';

      if (this.resultTitleEl) this.resultTitleEl.textContent = copy.title;

      this.summaryEl.replaceChildren();
      if (recap) {
        const recapNode = document.createElement('span');
        recapNode.className = 'kalaboost-quiz__recap';
        recapNode.textContent = recap;
        this.summaryEl.appendChild(recapNode);
      }
      const whyNode = document.createElement('span');
      whyNode.className = 'kalaboost-quiz__why';
      whyNode.textContent = copy.text;
      this.summaryEl.appendChild(whyNode);

      if (healthNotice) {
        this.noticeEl.hidden = false;
        this.noticeEl.textContent =
          'Le complément alimentaire n’est pas recommandé dans votre situation. Parlez-en à un professionnel de santé avant toute prise. Nous vous proposons donc une routine composée uniquement de soins externes.';
      } else {
        this.noticeEl.hidden = true;
      }

      const isPackOffer = profile.layout === 'pack';
      const packKey = profile.productKeys?.[0];
      this.panel?.classList.toggle('kalaboost-quiz__panel--offer', isPackOffer);
      this.productsEl?.classList.toggle('kalaboost-quiz__products--offer', isPackOffer);
      if (this.reassuranceEl) this.reassuranceEl.hidden = isPackOffer;

      let productsHtml = '';
      if (isPackOffer) {
        productsHtml = this.renderPackOffer(packKey, {
          intro: copy.intro,
          highlightHandles: highlights,
        }) || this.renderProductCard(packKey);
      } else {
        profile.productKeys.forEach((key) => {
          const product = this.config.products?.[key];
          const priority = Boolean(product?.handle && highlights.includes(product.handle));
          productsHtml += this.renderProductCard(key, { priority });
        });
      }

      this.productsEl.innerHTML = productsHtml;

      this.productsEl.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', () => {
          trackEvent('kalaboost_quiz_cta_click', { result_id: resultId, url: link.href });
        });
      });

      trackEvent('kalaboost_quiz_complete', {
        result_id: resultId,
        gender: this.answers.q1 || '',
        concern: concern || '',
        q6: this.answers.q6 || '',
      });
    }
  }

  let quizInstance = null;

  const init = () => {
    const root = document.querySelector(QUIZ_SELECTOR);
    if (!root || quizInstance) return;

    quizInstance = new KalaboostQuiz(root);

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest(OPEN_SELECTOR);
      if (!trigger || !quizInstance) return;

      event.preventDefault();
      quizInstance.open();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
